/**
 * Componente que almacena las imágenes subidas desde local. Se puede pinchar para subir la imagen
 * o arrastrar la imagen a la zona.
**/

import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import "../assets/Previews.css";

function Previews({ onImageUpload }) {

  /*********************************** VARIABLES DE COMPONENTE ***********************************/
  /***********************************************************************************************/
  const [imagenCargada, setImagenCargada] = useState(false);

  /***********************************************************************************************/
  /***********************************************************************************************/

  /*********************************** FUNCIONES DE COMPONENTE ***********************************/
  /***********************************************************************************************/
  //Función para guardar la imagen arrastrada como url o también si se pincha en la zona
  const { getRootProps, getInputProps } = useDropzone({
    accept: { "image/*": [] },
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        const preview = URL.createObjectURL(file);
        console.log("📸 Imagen detectada en Previews:", preview);
        setImagenCargada(true); 
        onImageUpload(preview);
      }
    },
  });

  /***********************************************************************************************/
  /***********************************************************************************************/

  return (
    <section className="container">
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        {imagenCargada ? (
          <p className="texto-subida">✅ Imagen subida. Haz clic para cambiarla<br></br> o arrastre una nueva foto.</p>
        ) : (
          <>
            <p className="p">Arrastra y suelta</p>
            <p className="p">o</p>
            <p className="subida">Sube desde el ordenador</p>
          </>
        )}
      </div>
    </section>
  );
}

export default Previews;